import { render, staticRenderFns } from "./full-screen-modal.vue?vue&type=template&id=17581621&scoped=true&"
import script from "./full-screen-modal.vue?vue&type=script&lang=js&"
export * from "./full-screen-modal.vue?vue&type=script&lang=js&"
import style0 from "./full-screen-modal.vue?vue&type=style&index=0&id=17581621&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17581621",
  null
  
)

export default component.exports